export interface Mascot {
  id: string
  name: string
  isAdult: boolean
  imagePath: string
  variants?: {
    happy?: string
    worried?: string
    neutral?: string
  }
}

export const MASCOTS: Record<string, Mascot> = {
  hönrietta: {
    id: 'hönrietta',
    name: 'Hönrietta',
    isAdult: true,
    imagePath: '/images/mascots/hönrietta.png',
    variants: {
      happy: '/images/mascots/hönrietta-happy.png',
      neutral: '/images/mascots/hönrietta.png',
    },
  },
  kornelia: {
    id: 'kornelia',
    name: 'Kornelia',
    isAdult: true,
    imagePath: '/images/mascots/kornelia.png',
    variants: {
      happy: '/images/mascots/kornelia-happy.png',
      neutral: '/images/mascots/kornelia.png',
    },
  },
  gristian: {
    id: 'gristian',
    name: 'Gristian',
    isAdult: false,
    imagePath: '/images/mascots/gristian.png',
    variants: {
      happy: '/images/mascots/gristian-happy.png',
      neutral: '/images/mascots/gristian.png',
    },
  },
  minkaela: {
    id: 'minkaela',
    name: 'Minkaela',
    isAdult: false,
    imagePath: '/images/mascots/minkaela.png',
    variants: {
      happy: '/images/mascots/minkaela-happy.png',
      neutral: '/images/mascots/minkaela.png',
    },
  },
  'kyck-linn': {
    id: 'kyck-linn',
    name: 'Kyck-linn',
    isAdult: false,
    imagePath: '/images/mascots/kyck-linn.png',
    variants: {
      happy: '/images/mascots/kyck-linn-happy.png',
      neutral: '/images/mascots/kyck-linn.png',
    },
  },
  laximilian: {
    id: 'laximilian',
    name: 'Laximilian',
    isAdult: false,
    imagePath: '/images/mascots/laximilian.png',
    variants: {
      happy: '/images/mascots/laximilian-happy.png',
      neutral: '/images/mascots/laximilian.png',
    },
  },
  rävmond: {
    id: 'rävmond',
    name: 'Rävmond',
    isAdult: false,
    imagePath: '/images/mascots/rävmond.png',
    variants: {
      happy: '/images/mascots/rävmond-happy.png',
      neutral: '/images/mascots/rävmond.png',
    },
  },
  kajnin: {
    id: 'kajnin',
    name: 'Kajnin',
    isAdult: false,
    imagePath: '/images/mascots/kajnin.png',
    variants: {
      happy: '/images/mascots/kajnin-happy.png',
      neutral: '/images/mascots/kajnin.png',
    },
  },
}

export const ADULT_MASCOTS = Object.values(MASCOTS).filter((mascot) => mascot.isAdult)
export const CHILD_MASCOTS = Object.values(MASCOTS).filter((mascot) => !mascot.isAdult)

export function getMascotById(id: string): Mascot | undefined {
  return MASCOTS[id.toLowerCase()]
}

export function getMascotsByIds(ids: string[]): Mascot[] {
  return ids
    .map((id) => getMascotById(id))
    .filter((mascot): mascot is Mascot => mascot !== undefined)
}

export function getMascotVariant(
  mascotId: string,
  variant: 'happy' | 'neutral' | 'worried' = 'neutral',
): string {
  const mascot = getMascotById(mascotId)
  if (!mascot) return ''

  return mascot.variants?.[variant] || mascot.imagePath
}
